import sellSound from '../assets/music/sell.mp3';

const SOUND_POOL_SIZE = 3;

const createPool = (src, size = SOUND_POOL_SIZE) => {
	const pool = Array.from({ length: size }, () => new Audio(src));
	let cursor = 0;
	return {
		pool,
		next() {
			for (let i = 0; i < pool.length; i += 1) {
				const a = pool[i];
				if (a.paused) return a;
			}
			const a = pool[cursor % pool.length];
			cursor += 1;
			return a;
		}
	};
};

// Статические звуки
const sounds = {
	sell: createPool(sellSound)
};

// Динамические пулы по src (для музыки открытия кейса)
const srcToPool = new Map();

const getPoolForSrc = (src) => {
	if (!src) return null;
	if (!srcToPool.has(src)) {
		srcToPool.set(src, createPool(src));
	}
	return srcToPool.get(src);
};

// Предзагрузка только известных статических звуков
Object.values(sounds).forEach(({ pool }) => {
	pool.forEach(sound => {
		try { sound.preload = 'auto'; } catch (_) { }
		try { sound.load(); } catch (_) { }
	});
});

let audioUnlocked = false;

export const setupAudioUnlock = () => {
	if (audioUnlocked || typeof window === 'undefined' || typeof document === 'undefined') return;

	const tryUnlock = async () => {
		const unlockPromises = [];
		// Разблокируем как статические, так и динамические пулы (на данный момент динамические создаются лениво)
		Object.values(sounds).forEach(({ pool }) => {
			pool.forEach(sound => {
				unlockPromises.push((async () => {
					try {
						const wasMuted = sound.muted;
						sound.muted = true; // iOS/Safari требует беззвучный старт
						await sound.play();
						sound.pause();
						sound.currentTime = 0;
						sound.muted = wasMuted;
					} catch (_) { }
				})());
			});
		});
		try {
			await Promise.allSettled(unlockPromises);
		} finally {
			audioUnlocked = true;
			['pointerdown', 'touchend', 'click'].forEach(evt => document.removeEventListener(evt, tryUnlock, true));
		}
	};

	['pointerdown', 'touchend', 'click'].forEach(evt => document.addEventListener(evt, tryUnlock, true));
};

export const playSound = (soundName, shouldPlay = true) => {
	if (!shouldPlay) return;

	const pool = sounds[soundName];
	if (pool) {
		const sound = pool.next();
		try { sound.currentTime = 0; } catch (_) { }
		sound.play().catch(error => {
			console.error('Error playing sound:', error);
		});
	}
};

export const playMp3 = (src, shouldPlay = true) => {
	if (!shouldPlay || !src) return;
	const pool = getPoolForSrc(src);
	if (!pool) return;
	const sound = pool.next();
	try { sound.currentTime = 0; } catch (_) { }
	sound.play().catch(error => {
		console.error('Error playing sound:', error);
	});
};

export const primeSound = async (soundName) => {
	const pool = sounds[soundName];
	if (!pool) return;
	const sound = pool.next();
	try {
		const wasMuted = sound.muted;
		sound.muted = true;
		await sound.play();
		sound.pause();
		sound.currentTime = 0;
		sound.muted = wasMuted;
	} catch (_) { }
};

export const stopAllSounds = () => {
	Object.values(sounds).forEach(({ pool }) => {
		pool.forEach(sound => {
			sound.pause();
			sound.currentTime = 0;
		});
	});
	// Останавливаем и динамические, если они уже созданы
	srcToPool.forEach(({ pool }) => {
		pool.forEach(sound => {
			sound.pause();
			sound.currentTime = 0;
		});
	});
}; 